import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { AnimatePresence, motion } from "framer-motion";
import { MoreHorizontalIcon, PencilIcon, Trash2Icon } from "lucide-react";

interface ChatHistoryItemMenuProps {
	onRename: () => void;
	onDelete: () => void;
}

const ChatHistoryItemMenu = ({
	onRename,
	onDelete,
}: ChatHistoryItemMenuProps) => (
	<Menu>
		{({ open }) => (
			<div className="relative">
				<MenuButton
					aria-label="More options"
					className="flex size-6 items-center justify-center rounded transition-colors hover:text-slate-600 dark:text-slate-500 dark:hover:text-slate-300"
				>
					<MoreHorizontalIcon className="size-4" />
				</MenuButton>

				<AnimatePresence>
					{open && (
						<MenuItems
							static
							as={motion.div}
							initial={{ opacity: 0, y: -5 }}
							animate={{ opacity: 1, y: 0, transition: { duration: 0.2 } }}
							exit={{ opacity: 0, y: -5, transition: { duration: 0.1 } }}
							className="absolute top-full right-0 z-10 mt-1 flex w-40 flex-col gap-0 rounded-xl border bg-white p-1.5 shadow-black/5 shadow-xl dark:bg-slate-800"
						>
							<MenuItem>
								<button
									type="button"
									onClick={onRename}
									className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-lg px-3 py-1.5 font-medium transition-colors hover:bg-sky-50 dark:hover:bg-sky-300/10"
								>
									<PencilIcon className="size-4 shrink-0" />
									Rename
								</button>
							</MenuItem>
							<MenuItem>
								<button
									type="button"
									onClick={onDelete}
									className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-lg px-3 py-1.5 font-medium text-red-600 transition-colors hover:bg-red-50 dark:text-red-400 dark:hover:bg-red-950/30"
								>
									<Trash2Icon className="size-4 shrink-0" />
									Delete
								</button>
							</MenuItem>
						</MenuItems>
					)}
				</AnimatePresence>
			</div>
		)}
	</Menu>
);

export default ChatHistoryItemMenu;
